










































import { Component, Inject, Vue } from "vue-property-decorator";
import {
  ITemplateProvider,
  ITemplateProviderMethods
} from "@/models/providers/templates";
import ClientTemplateForm from "@/components/app/admin/clientTemplates/templateForm.vue";
import NotificationsTemplateAddEditForm from "@/components/app/global/templates/notifications/templateAddEditForm.vue";

@Component({
  components: {
    ClientTemplateForm,
    NotificationsTemplateAddEditForm
  }
})
export default class TemplateAddEditModal extends Vue {
  // Refs

  public declare $refs: {
    form: ClientTemplateForm | NotificationsTemplateAddEditForm;
  };

  // Inject

  @Inject({ from: "templateProvider" })
  public templateProvider!: () => ITemplateProvider;

  @Inject({ from: "templateProviderMethods" })
  public $templateMethods!: ITemplateProviderMethods;

  // Computed

  public get $templateData() {
    return this.templateProvider();
  }

  // Methods

  public onSuccess(args: any) {
    this.$emit("success", args);
    this.$emit("close");
  }
}
